export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SET_REMEMBER_ME = "SET_REMEMBER_ME";
export const CLEAR_REMEMBER_ME = "CLEAR_REMEMBER_ME";
export const SET_APP_SETTING = "SET_APP_SETTING";
// Zoco rotó el par de tokens de una sesión que salió de su canje (api/api.js). Cambia solo los
// tokens: el usuario y el negocio siguen siendo los del canje.
export const SESION_ZOCO_RENOVADA = "SESION_ZOCO_RENOVADA";
